// Fallback until Company Information → Quote Options loads (owner-managed in /settings/quote-options).
export const QUOTE_OPTION_DEFAULTS = {
  currencies: ["TZS", "USD"],
  incoterms: ["EXW Dar Es Salaam, Tanzania", "CIF", "FOB", "DDP Client Premises"],
  payment_terms: [
    "100% on PO Placement",
    "30% on PO and 70% 30 Days After Date of Invoice",
    "50% on PO Placement and 50% 30 Days After Date of Invoice",
  ],
  validity: ["7 Days", "14 Days", "30 Days", "60 Days", "90 Days"],
};
